import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import NumberFormat from 'react-number-format';
import { Container } from '../Container';
import { TutorialHeader } from '../TutorialHeader';
import washington from './../../assets/washingtonTut.jpg';
import { ScoreChart } from '../ScoreChart';
import { SlideProps } from './types';
import { getScore } from '../../helpers';
import { getTutorialImageStyle } from '../commonStyleSheets';
import { FunFact } from './../Game/FunFact';
import { HomeButton } from './HomeButton';
import { NextButton } from './NextButton';
import { FormattedMessage, useIntl } from 'react-intl';
import ScoreMessage from '../ScoreMessage';
import { tutorialText } from './styles';

const imageStyle = getTutorialImageStyle(washington);

const Slide10 = ({ handleNextStep, currentTip }: SlideProps) => {
  const intl = useIntl();
  const fact = intl.formatMessage({
    id: 'app.tutorial.slide.ffwash',
    defaultMessage: `Washington's head measures {correct} meters. The original plan for the sculptures was to depict prominent figures of the American West, including Native Americans. The presidents were eventually depicted to give the statue a "broader meaning".`,
    description: 'Tut10 washington funfact',
  });
  const correctAnswer = 18.29;
  const previousTips = [28, 105];
  const questionScore = getScore(
    typeof currentTip === 'undefined' ? 0 : currentTip,
    18.29
  );
  return (
    <Container>
      <TutorialHeader>
        <Typography
          fontSize={{
            xs: 20,
            sm: 24,
            md: 28,
          }}
          color="accent.main"
          textAlign="center"
          p={3}
        >
          {' '}
          <NumberFormat
            value={currentTip}
            displayType={'text'}
            thousandSeparator={' '}
          />{' '}
          <FormattedMessage
            id="app.tutorial.slide.metersq"
            defaultMessage="meters?"
            description="Tut10 meters?"
          />{' '}
          <Typography
            component="span"
            sx={tutorialText}
          >
            {' '}
            {questionScore === 0 && <ScoreMessage question="Slide10" scoreType="score.zero" />}
            {questionScore !== null &&
              questionScore > 0 &&
              questionScore < 40 && <ScoreMessage question="Slide10" scoreType="score.low" />}
            {questionScore !== null &&
              questionScore >= 40 &&
              questionScore < 80 && <ScoreMessage question="Slide10" scoreType="score.high" />}
            {questionScore !== null &&
              questionScore >= 80 &&
              questionScore < 95 && <ScoreMessage question="Slide10" scoreType="score.top" />}
          </Typography>
        </Typography>
      </TutorialHeader>
      <Box sx={imageStyle} />
      <Box width="100%" height="200px">
        {typeof currentTip !== 'undefined' && (
          <ScoreChart
            currentTip={currentTip}
            correctAnswer={correctAnswer}
            previousTips={previousTips}
          />
        )}
      </Box>
      <Box px={2}>
        <FunFact correctAnswer={correctAnswer} fact={fact} />
      </Box>
      <Box mt="auto" display="flex" justifyContent="space-between" width="100%">
        <HomeButton />
        <NextButton handleNextStep={handleNextStep} />
      </Box>
    </Container>
  );
};

export { Slide10 };
